import produce from 'immer';

import {
  PICKUP_VALIDATION_LOAD,
  PICKUP_VALIDATION_LOAD_SUCCESS,
  PICKUP_VALIDATION_LOAD_FAILURE,
  PICKUP_VALIDATION_START,
  PICKUP_VALIDATION_START_SUCCESS,
  PICKUP_VALIDATION_START_FAILURE,
  PICKUP_VALIDATION_VERIFY,
  PICKUP_VALIDATION_VERIFY_SUCCESS,
  PICKUP_VALIDATION_VERIFY_FAILURE,
  PICKUP_VALIDATION_SUPPORT_RELEASE,
  PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS,
  PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE,
  PICKUP_VALIDATION_RELEASE,
  PICKUP_VALIDATION_RELEASE_SUCCESS,
  PICKUP_VALIDATION_RELEASE_FAILURE,
  PICKUP_VALIDATION_CANCEL,
  PICKUP_VALIDATION_CANCEL_SUCCESS,
  PICKUP_VALIDATION_CANCEL_FAILURE,
  PICKUP_VALIDATION_UPLOAD_PHOTO,
  PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS,
  PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE,
  PICKUP_VALIDATION_DISPATCHED_RECEIVED,
  PICKUP_VALIDATION_OPEN_MODAL,
  PICKUP_VALIDATION_CLOSE_MODAL,
  PICKUP_VALIDATION_RESET,
} from './actionsTypes';

const initialState = {
  validation: null,
  loading: false,
  loadingVerify: false,
  loadingSupportRelease: false,
  loadingRelease: false,
  loadingCancel: false,
  loadingPhoto: false,
  error: null,
  isModalOpen: false,
};

export default function pickupValidation(state = initialState, action) {
  return produce(state, draft => {
    switch (action.type) {
      // LOAD
      case PICKUP_VALIDATION_LOAD:
        draft.loading = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_LOAD_SUCCESS:
        draft.loading = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_LOAD_FAILURE:
        draft.loading = false;
        draft.error = action.payload.error;
        break;

      // START
      case PICKUP_VALIDATION_START:
        draft.loading = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_START_SUCCESS:
        draft.loading = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_START_FAILURE:
        draft.loading = false;
        draft.error = action.payload.error;
        break;

      // VERIFY
      case PICKUP_VALIDATION_VERIFY:
        draft.loadingVerify = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_VERIFY_SUCCESS:
        draft.loadingVerify = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_VERIFY_FAILURE:
        draft.loadingVerify = false;
        draft.error = action.payload.error;
        break;

      // SUPPORT RELEASE
      case PICKUP_VALIDATION_SUPPORT_RELEASE:
        draft.loadingSupportRelease = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS:
        draft.loadingSupportRelease = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE:
        draft.loadingSupportRelease = false;
        draft.error = action.payload.error;
        break;

      // RELEASE
      case PICKUP_VALIDATION_RELEASE:
        draft.loadingRelease = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_RELEASE_SUCCESS:
        draft.loadingRelease = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_RELEASE_FAILURE:
        draft.loadingRelease = false;
        draft.error = action.payload.error;
        break;

      // CANCEL
      case PICKUP_VALIDATION_CANCEL:
        draft.loadingCancel = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_CANCEL_SUCCESS:
        draft.loadingCancel = false;
        draft.validation = action.payload.validation;
        draft.isModalOpen = false;
        break;

      case PICKUP_VALIDATION_CANCEL_FAILURE:
        draft.loadingCancel = false;
        draft.error = action.payload.error;
        break;

      // PHOTO
      case PICKUP_VALIDATION_UPLOAD_PHOTO:
        draft.loadingPhoto = true;
        draft.error = null;
        break;

      case PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS:
        draft.loadingPhoto = false;
        draft.validation = action.payload.validation;
        break;

      case PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE:
        draft.loadingPhoto = false;
        draft.error = action.payload.error;
        break;

      // ECHO: dispatched recebido
      // Atualiza a validação atual se for da mesma sessão
      case PICKUP_VALIDATION_DISPATCHED_RECEIVED:
        if (
          draft.validation &&
          draft.validation.id === action.payload.validation_id
        ) {
          draft.validation.status = 'dispatched';
          draft.validation.dispatched_at = action.payload.dispatched_at;
          if (typeof action.payload.skipped_validation === 'boolean') {
            draft.validation.skipped_validation =
              action.payload.skipped_validation;
          }
        }
        break;

      // MODAL
      case PICKUP_VALIDATION_OPEN_MODAL:
        draft.isModalOpen = true;
        break;

      case PICKUP_VALIDATION_CLOSE_MODAL:
        draft.isModalOpen = false;
        break;

      // RESET
      case PICKUP_VALIDATION_RESET:
        draft.validation = null;
        draft.loading = false;
        draft.loadingVerify = false;
        draft.loadingSupportRelease = false;
        draft.loadingRelease = false;
        draft.loadingCancel = false;
        draft.loadingPhoto = false;
        draft.error = null;
        draft.isModalOpen = false;
        break;

      default:
    }
  });
}
